import createReducer from './create-reducer';

const initial = {};
const reducers = {};

export default createReducer(initial, reducers);
